{
  "topMenu": {
    "dihTitle": "Data Intelligence Hub",
    "dihSubTitle": "Extraire de la valeur des données en toute sécurité",
    "logout": "Déconnexion",
    "dihPortal": "Portail DIH",
    "cofinityDataspace": "Portail Dataspace"
  },
  "userLogoutAlert": {
    "title": "Êtes-vous sûr de vouloir vous déconnecter ?",
    "back": "Retour",
    "logout": "Déconnexion"
  },
  "languages": {
    "en": "English",
    "de": "German (Deutsch)",
    "es": "Spanish (Español)",
    "fr": "French (Français)",
    "zh": "Chinese (中文/简体)",
    "ja": "Japanese (日本語)"
  },
  "sideMenu": {
    "home": "Accueil",
    "collapse": "Réduire la barre latérale",
    "help": "Aide",
    "prepare": "Gestion des modèles",
    "model": "Modèle de données",
    "mapping": "Mappage de données",
    "converter": "Convertisseur de données",
    "provide": "Fournir",
    "publishData": "Publier des données",
    "assets": "Actifs",
    "policyPublicationTemplate": "Modèle de publication de politique",
    "uploadHistory": "Historique des téléchargements d'actifs",
    "consume": "Consommer",
    "searchDataOffers": "Rechercher des offres de données",
    "negotiatedDataOffers": "Offres de données négociées",
    "downloadHistory": "Historique des téléchargements d'actifs",
    "govern": "Gouverner",
    "myPolicies": "Mes politiques",
    "createPolicies": "Créer des politiques",
    "policyTemplate": "Modèles de politiques",
    "manageAndConfig": "Configurer",
    "connections": "Gérer les connecteurs",
    "jobs": "Journaux de processus",
    "monitoring": "Surveiller",
    "licences": "Licences",
    "providedAgreements": "Accords de contrat fournis",
    "incomingAgreements": "Offres de données entrantes",
    "consumedAgreements": "Accords de contrat consommés",
    "consumeAutomation": "Automatisation des politiques de consommation",
    "networkAnalytics": "Analyses réseau",
    "otherLogs": "Autres journaux",
    "digitalTwin": "Explorateur de jumeaux numériques",
    "messagesBrowserInbound": "Messages entrants",
    "messagesBrowserOutbound": "Messages sortants",
    "applications": "Applications",
    "pcfExchange": "PCF exchange",
    "pcfRequests": "Demandes de données PCF",
    "pcfExchangeHistory": "Historique d'échange de données PCF",
    "publicationTemplates": "Modèles de publication",
    "certificateManagement": "Gestion des certificats",
    "certificates": "Certificats",
    "connectors": "Mes connecteurs",
    "contractDefinitions": "Mes définitions de contrat"
  },
  "versionModal": {
    "title": "Informations générales",
    "error": "Impossible de récupérer les détails de la version",
    "table": {
      "title": "Détails du composant",
      "componentName": "Nom du composant",
      "imageVersion": "Version de l'image",
      "chartVersion": "Version du graphique"
    }
  },
  "dropdown": {
    "selectAll": "Tout sélectionner",
    "noOption": "Aucune option disponible",
    "noSuchOption": "Il n'y a pas d'option comme ça ...",
    "selectConnection": "Sélectionner une connexion"
  },
  "certificateManagement": {
    "title": "Gestion des certificats de partenaires commerciaux",
    "description": "Bienvenue dans la solution d'échange de gestion de certificats de partenaires commerciaux facile à utiliser dans Catena-X.",
    "howTo": {
      "description": "Découvrez le catalogue d'offres de données d'autres entreprises membres de Catena-X. Vous pouvez rechercher, sélectionner et vous abonner à une offre de certificat. Vous pouvez rechercher des offres de certificats en utilisant le nom de l'entreprise.",
      "doc": "Vous voulez en savoir plus sur le fonctionnement de la gestion des certificats de partenaires commerciaux ? "
    },
    "landingTiles": {
      "tile_1": {
        "title": "Publier un certificat",
        "description": "Créez et partagez vos certificats de site dans le réseau Catena-X."
      },
      "tile_2": {
        "title": "Découvrir et consommer des certificats",
        "description": "Recherchez et téléchargez facilement des certificats de site et d'entreprise."
      },
      "tile_3": {
        "title": "Historique de publication des certificats",
        "description": "Vue d'ensemble de tous vos certificats fournis"
      },
      "tile_4": {
        "title": "Historique des certificats consommés",
        "description": "Vue d'ensemble de tous vos certificats consommés"
      },
      "tile_5": {
        "title": "Demandes entrantes de certificats",
        "description": "Vue d'ensemble des demandes entrantes pour partager des certificats"
      },
      "tile_6": {
        "title": "Statut des certificats sortants",
        "description": "Vue d'ensemble des actions de partage de certificats"
      },
      "tile_7": {
        "title": "Demander des certificats",
        "description": "Recherchez et téléchargez facilement des certificats de site et d'entreprise."
      }
    },
    "recentCertificateRequests": "Demandes récentes de données de certificats entrantes",
    "learnMore": "En savoir plus sur la gestion des certificats",
    "requestCertificates": "Demander de nouveaux certificats",
    "pushCertificate": "Envoyer un certificat",
    "pushDescription": "Le certificat existant sera partagé avec le partenaire sélectionné ci-dessous. Veuillez noter que le même ensemble de politiques s’appliquera, comme dans l’offre d’origine. Si vous souhaitez modifier les politiques, veuillez créer une nouvelle offre de données.",
    "pushSuccess": "Le processus de promotion des certificats a commencé ! L’identifiant du poste est {id}",
    "receiverBpn": "Récepteur BPN",
    "providerBpn": "BPN du fournisseur",
    "locationBpns": "Localisation BPNs",
    "certificateType": "Type de certificat",
    "requestSuccess": "Demande de certificat soumise avec succès!",
    "pushResult": "{successful} sur {total} demandes {status} ont réussi",
    "receiveConfirmTitle": "Accuser réception du certificat",
    "receiveConfirmDesc": "En cliquant sur Oui, vous confirmez avoir reçu le certificat partagé par le partenaire. Le fournisseur recevra votre accusé de réception. Ensuite, vous pouvez accepter ou rejeter le certificat.",
    "acceptedConfirmTitle": "Accepter le certificat",
    "acceptedConfirmDesc": "En cliquant sur Oui, vous acceptez que le certificat corresponde à vos attentes. Vous pouvez télécharger le certificat au format PDF en cliquant sur l’icône d’affichage.",
    "rejectedConfirmTitle": "Rejeter le certificat",
    "rejectedConfirmDesc": "En cliquant sur Oui, vous rejetez le certificat entrant. Le fournisseur sera informé du rejet. Il pourra le partager à nouveau ou vous pourrez en demander un nouveau.",
    "processStarted": "'{type}' Le processus a commencé ! L’identifiant du poste est {id}",
    "certificateDetails": "Détails du certificat",
    "availableCertificate": "Emplacement du certificat disponible",
    "updateSuccess": "Certificat mis à jour avec succès!",
    "updateFailure": "La mise à jour du certificat a échoué!"
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "Informations de base du certificat",
        "issuer": "Informations de l'émetteur",
        "validity": "Période de validité",
        "trust": "Informations de confiance",
        "validator": "Informations du validateur",
        "application": "Domaine d'application",
        "enclosedSites": "Sites inclus"
      },
      "fields": {
        "businessPartnerNumber": "Numéro de partenaire commercial",
        "registrationNumber": "Numéro d'enregistrement",
        "certificateType": "Type de certificat",
        "certificateVersion": "Version du certificat",
        "issuerName": "Nom de l'émetteur",
        "issuerBpn": "BPN de l'émetteur",
        "validFrom": "Valide à partir de",
        "validUntil": "Valide jusqu'à",
        "trustLevel": "Niveau de confiance",
        "uploaderBpn": "BPN du téléchargeur",
        "validatorBpn": "BPN du validateur",
        "validatorName": "Nom du validateur",
        "areaOfApplication": "Domaine d'application",
        "siteBpn": "BPN du site",
        "siteAreaOfApplication": "Domaine d'application du site"
      },
      "tooltips": {
        "basicInfo": "Un certificat de partenaire commercial décrit un certificat (par exemple ISO9001, IATF-16949) via un document de certificat d'un partenaire commercial Catena-X",
        "businessPartnerNumber": "Le numéro de partenaire commercial (BPN) de l'entité juridique certifiée (sur laquelle le certificat est émis).",
        "registrationNumber": "Numéro d'enregistrement du certificat tel que défini sur le certificat",
        "certificateType": "Type de certificat tel que défini sur le document, les types valides sont enregistrés au contrôleur de métadonnées BPN",
        "certificateVersion": "Version du certificat telle que définie sur le document, généralement la version spécifique d'une norme de certification",
        "issuerName": "Nom de l'émetteur, c'est-à-dire de l'autorité de certification.",
        "issuerBpn": "Le numéro de partenaire commercial (BPN) de l'émetteur.",
        "validFrom": "Date de validité à partir de, telle que définie sur le certificat.",
        "validUntil": "Valide jusqu'à la date définie sur le certificat. Si le certificat n'expire jamais, la valeur attendue est 9999-12-31",
        "trustLevel": "Le niveau de confiance du certificat donné - none, low, high, trusted",
        "uploaderBpn": "Le numéro de partenaire commercial (BPN) du partenaire commercial qui a fourni à l'origine les données ou le document du certificat.",
        "validatorBpn": "Le numéro de partenaire commercial (BPN) du fournisseur de services de données qui a validé le certificat donné",
        "validatorName": "Le nom optionnel du fournisseur de services de données qui a validé le certificat donné",
        "areaOfApplication": "Détails sur les domaines / types d'applications pour lesquels un certificat est valide pour une entreprise et/ou un site.",
        "siteBpn": "Le numéro de partenaire commercial (BPNS ou BPNA) d'un site inclus",
        "siteAreaOfApplication": "Détails sur les domaines / types d'applications pour lesquels un certificat est valide pour une entreprise et/ou un site."
      }
    }
  },
  "common": {
    "start": "Démarrer",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Adresse e-mail",
    "phoneNumber": "Numéro de téléphone",
    "contactPerson": "Personne à contacter",
    "welcome": "Bienvenue",
    "street": "Rue",
    "city": "Ville",
    "country": "Pays",
    "postCode": "Code postal",
    "number": "Numéro",
    "next": "Suivant",
    "prev": "Retour",
    "alreadyAccount": "Vous avez déjà un compte ?",
    "login": "Se connecter",
    "loginNow": "Se connecter maintenant",
    "register": "S'inscrire",
    "home": "Accueil",
    "submit": "Soumettre",
    "attention": "Attention",
    "desc": "Description",
    "website": "Site web",
    "contact": "Contact",
    "details": "Détails",
    "plan": "Plan",
    "table": "Table",
    "grid": "Grille",
    "listView": "Vue en liste",
    "gridView": "Vue en grille",
    "firstPage": "À la première page",
    "previousPage": "À la page précédente",
    "nextPage": "À la page suivante",
    "lastPage": "À la dernière page",
    "paginationUnknownButton": "Type de bouton de pagination inconnu",
    "download": "Télécharger",
    "delete": "Supprimer",
    "edit": "Modifier",
    "information": "Information",
    "organization": "Organisation",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "upload": "Télécharger",
    "link": "Lien",
    "view": "Voir",
    "search": "Rechercher",
    "searchTerm": "Rechercher",
    "selectOption": "Sélectionner une option",
    "sortBy": "Trier par",
    "dataspace": "Espace de données",
    "select": "Sélectionner",
    "date": "Date",
    "title": "Titre",
    "back": "Retour",
    "startTyping": "Commencer à taper",
    "useCases": "Cas d'utilisation",
    "done": "Terminé",
    "enterValue": "Saisir une valeur",
    "selectValue": "Sélectionner une valeur",
    "selectDate": "Sélectionner une date",
    "refresh": "Actualiser",
    "searchByName": "Rechercher par nom",
    "close": "Fermer",
    "copyToClipboard": "Copié dans le presse-papiers !",
    "enterKeyName": "Saisir le nom de la clé",
    "fileDownloadSuccess": "Fichier téléchargé avec succès",
    "fileDownloadError": "Échec du téléchargement du fichier",
    "certificate": "Certificat",
    "manageConnections": "Gérer les connexions",
    "confirm": "Confirmer",
    "yes": "Oui",
    "no": "Non",
    "connectionDetails": "{type} Détails de la connexion",
    "hide": "Cacher",
    "unpublish": "Inébranlable",
    "clear": "Clair"
  },
  "genericError": "Oh, quelque chose s'est mal passé ! Veuillez réessayer.",
  "validation": {
    "fieldRequired": "{field} est requis.",
    "fieldNumeric": "Le champ {field} ne peut contenir que des chiffres.",
    "fieldAlpha": "Le champ {field} ne peut contenir que des lettres, _ et -.",
    "fieldAlphanumeric": "Le champ {field} ne peut contenir que des lettres, des chiffres, _ et -.",
    "fieldNumericDash": "Le champ {field} ne peut contenir que des chiffres et -.",
    "fieldHouseNumber": "Le champ {field} ne peut contenir que des chiffres, des lettres et les caractères - et /.",
    "fieldPhoneNumber": "Le champ {field} ne peut contenir que des chiffres et -. Il doit commencer par + ou 00.",
    "fieldAlphaDash": "Le champ {field} ne peut contenir que des lettres et -.",
    "exceptHTMLTagBrackets": "Le champ {field} ne doit pas contenir les caractères suivants : ^<>",
    "isMaxLength": "dépasse la longueur maximale de 10 caractères.",
    "emailFormat": "L'adresse e-mail a un format incorrect",
    "fileSizeError": "La taille du fichier est supérieure à {size} MB.",
    "csvFileSizeError": "Ce fichier est trop volumineux. Vous pouvez télécharger un fichier jusqu'à {size} MB.",
    "csvFileExtensionError": "Seuls les fichiers avec l'extension csv sont autorisés.",
    "csvFileIsEmptyError": "Ce fichier est vide. Vous devez télécharger un fichier d'au moins {size} KB.",
    "csvFileFormatError": "Le fichier ne correspond pas au format attendu. Veuillez utiliser le modèle fourni et réessayer.",
    "uploadFails": "échec du téléchargement",
    "fileExtensionError": "L'extension de fichier n'est pas appropriée",
    "fileIsMalwareInfectedError": "Ce fichier semble contenir des logiciels malveillants. Pour des raisons de sécurité, ce fichier ne peut pas être téléchargé. Veuillez vérifier à nouveau votre fichier",
    "customValidation": "Le {field} a un format incorrect.",
    "selectCountryFirst": "Veuillez d'abord sélectionner le pays",
    "validationPostCodeCaseDE": "Le champ a un format incorrect. Il doit contenir 5 chiffres, par ex., 53113",
    "validationAlphanumericCase": "Le champ ne peut contenir que des caractères alphanumériques, des tirets et des traits de soulignement. La valeur doit commencer par un caractère alphanumérique.",
    "validationNumericDashCase": "Le champ ne peut contenir que des chiffres et -.",
    "url": "Veuillez entrer une URL valide",
    "required": "Ce champ est obligatoire",
    "password": {
      "passwordStrength": "Force du mot de passe",
      "weak": "Faible",
      "average": "Moyen",
      "strong": "Fort",
      "passwordValidationMoreChar": "{count} caractères ou plus",
      "passwordUpperAndLowerChar": "Caractères majuscules et minuscules",
      "passwordAtLeastNumber": "Au moins un chiffre",
      "passwordAtLeastSpecialChar": "Au moins un caractère spécial (sauf <>&\"`[])",
      "passwordDiffFromPrev": "Diffère de vos mots de passe précédents"
    }
  },
  "footer": {
    "tagLine": "Développons de meilleures performances",
    "imprint": "Mentions légales",
    "imprintShort": "Mentions",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "Contact",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "Conditions générales",
    "privacy": "Politique de confidentialité",
    "privacyShort": "Confidentialité",
    "telekom": "T-Systems International GmbH. Tous droits réservés.",
    "telekomShort": "T-Systems International GmbH",
    "note": "Telekom Data Intelligence Hub - Uniquement pour les clients professionnels",
    "brandedNote": "Propulsé par Telekom Data Intelligence Hub",
    "help": "Aide",
    "cookieSettings": "Paramètres des cookies",
    "cookieSettingsShort": "Cookies",
    "life": "La vie est faite pour être partagée"
  },
  "cookieSettings": {
    "collapsedTitle": "Paramètres de confidentialité",
    "collapsedText": "Ce site web utilise des cookies et technologies similaires. Ce sont de petits fichiers texte qui sont stockés et lus sur votre ordinateur. En cliquant sur '{0}', vous acceptez le traitement, la création de profils utilisateur individuels sur des sites web et des partenaires, et le transfert de vos données à des tiers, dont certains traitent vos données dans des pays hors de l'Union européenne (RGPD Art. 49). Les détails se trouvent dans la section '2 de la {1}. Les données sont utilisées pour l'analyse, le reciblage et pour diffuser du contenu personnalisé et de la publicité sur les sites Telekom et des sites tiers. Plus d'informations, y compris des informations sur le traitement des données par des tiers et la possibilité de rétractation, peuvent être trouvées dans les paramètres et dans nos informations sur la confidentialité. Ici, vous pouvez {2} uniquement avec les outils nécessaires.",
    "extendedTitle": "Paramètres de confidentialité",
    "extendedText": "Afin de vous offrir une expérience optimale du site web, nous utilisons des cookies. Ceux-ci incluent des cookies pour le fonctionnement et l'optimisation du site ainsi que pour des services tels que le chat texte ou vidéo et pour la publicité basée sur votre comportement d'utilisation en ligne. Cela nous permet, par exemple, de détecter si vous visitez nos pages de façon répétée depuis le même appareil. Nous aimerions vous donner le choix des cookies que vous autorisez :",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "informations sur la confidentialité",
    "policyLinkText": "Informations sur la confidentialité",
    "rejectLinkText": "continuer",
    "acceptButton": "Tout accepter",
    "saveButton": "Enregistrer les paramètres",
    "settingsButton": "Modifier les paramètres",
    "showMore": "Afficher plus",
    "showLess": "Afficher moins",
    "categoryTitleEssential": "Cookies nécessaires",
    "categoryTitleAnalytics": "Cookies analytiques",
    "categoryTitleMarketing": "Cookies marketing",
    "categoryTitleThirdParty": "Services d'autres entreprises (fournisseurs tiers indépendants)",
    "categoryTextEssential": "Ces cookies sont nécessaires pour vous permettre de naviguer sur les sites web et d'utiliser les fonctions clés. Ils prennent en charge les fonctions de base, telles que le traitement des commandes dans la boutique en ligne et l'accès aux zones sécurisées du site web. Ils servent également à effectuer une analyse anonyme des modèles d'utilisation, que nous utilisons pour développer et améliorer continuellement nos pages web pour vous.",
    "categoryTextAnalytics": "Ces cookies nous aident à améliorer notre compréhension du comportement des utilisateurs. Les cookies d'analyse permettent la compilation de données d'utilisation et d'identification par le fournisseur original ou des fournisseurs tiers en profils d'utilisation pseudonymes. Nous utilisons des cookies d'analyse par exemple pour déterminer le nombre de visiteurs individuels d'une page web ou d'un service, pour recueillir des données statistiques sur les performances de nos produits et pour analyser les modèles d'utilisation des visiteurs et les interactions des visiteurs sur la base d'informations anonymes et pseudonymes. Ces informations ne peuvent pas être retracées à une personne.",
    "categoryTextMarketing": "Ces cookies et technologies similaires sont utilisés pour permettre l'affichage de contenu marketing personnalisé et donc pertinent. Les cookies marketing sont utilisés pour afficher du contenu publicitaire intéressant et pour mesurer l'efficacité de nos campagnes. Cela se produit non seulement sur les sites web de Telekom, mais aussi sur d'autres sites partenaires publicitaires (fournisseurs tiers). C'est ce qu'on appelle aussi le reciblage. Il est utilisé pour créer des profils de contenu ou d'annonces pseudonymes, pour placer des publicités pertinentes sur d'autres sites web, et pour tirer des enseignements sur les groupes cibles qui ont vu les annonces et le contenu. Ces informations ne peuvent pas être retracées à une personne. Les outils de marketing et de reciblage nous aident à vous proposer du contenu publicitaire potentiellement pertinent pour vous. En supprimant les cookies marketing, vous verrez toujours la même quantité de publicité, mais elle pourrait être moins pertinente pour vous.",
    "categoryTextThirdParty": "Les sites web de Telekom incluent des liens vers des fournisseurs de services tiers, qui fournissent leurs services sous leur propre responsabilité. Lorsque vous visitez les pages web de Telekom, des cookies ou des technologies similaires enregistrent des données et les envoient à des tiers, en partie pour les propres besoins de Telekom. La portée, la finalité et la base juridique sur lesquelles un traitement ultérieur est effectué pour les propres besoins du tiers peuvent être trouvées dans les informations sur la confidentialité des données du tiers. Des informations sur les fournisseurs tiers indépendants peuvent être trouvées dans les informations sur la confidentialité des données."
  },
  "messages": {
    "noDataAvailable": "Aucune donnée disponible",
    "noMatchFound": "Aucune correspondance trouvée",
    "maximumFileSize": "Taille maximale de fichier",
    "suitableFileFormats": "Formats de fichier appropriés",
    "loading": "Chargement...",
    "dragDropText": "ou glissez-déposez ici",
    "noConnectors": "Aucun connecteur trouvé !",
    "comingSoon": "Bientôt disponible"
  },
  "pageNotFound": {
    "title": "Oups ! Il semble que la page que vous recherchez n'existe pas encore.",
    "subtitle": "Consultez nos autres ressources en attendant, qui pourraient vous être utiles !"
  },
  "helpResources": {
    "needHelp": "Besoin d'aide pour trouver le bon plan, plus d'informations, des questions techniques ?",
    "developerDoc": "Documentation pour intégrateurs",
    "developerDocDesc": "Obtenir la documentation API pour commencer",
    "example": "Exemple",
    "tutorials": "Tutoriels",
    "exampleDescription": "Trouvez des cas d'utilisation et des démos pertinents pour votre secteur industriel",
    "FAQ": "Questions fréquemment posées",
    "FAQDescription": "Trouvez plus de réponses communes de la facturation à la confidentialité",
    "browse": "Parcourir",
    "demos": "Démos",
    "demosDescription": "Trouvez des cas d'utilisation et des démos pertinents pour votre secteur industriel",
    "glossary": "Glossaire",
    "glossaryDescription": "Trouvez les termes et définitions liés à Data Intelligence Hub, IDSA, Catena-X, Gaia-X et plus.",
    "contactUs": "Cette fonctionnalité n'est pas prise en charge dans votre abonnement actuel. Veuillez nous contacter pour mettre à niveau."
  },
  "feedbackCard": {
    "title": "Besoin de plus d'aide ?",
    "contactUs": "Contactez-nous"
  },
  "error": {
    "pageNotFound": "Page non trouvée (404)",
    "somethingWrong": "Quelque chose s'est mal passé !",
    "propertyNotFound": "Propriété non trouvée",
    "uniquePropertyName": "Le nom de la propriété doit être unique",
    "dctTypeNotFound": "dct:type non trouvé"
  },
  "helpWidget": {
    "askSupport": "Demander de l'aide",
    "chatboxTitle": "Chat d'aide",
    "chatboxSubtitle": "Support Telekom Data Intelligence Hub",
    "defaultMessage": {
      "body": "Bonjour, bienvenue sur le canal de support Telekom Data Intelligence Hub. Veuillez sélectionner une option ci-dessous."
    },
    "whatCanWeHelpWith": "Comment pouvons-nous vous aider aujourd'hui ?",
    "suggestedAnswers": {
      "knowledgeBase": "Base de connaissances, documentation et FAQs",
      "contactSupport": "Contacter le support",
      "contactSales": "Contacter les ventes"
    }
  },
  "pcfExchange": {
    "title": "PCF Exchange",
    "description": "Bienvenue dans la solution d'échange de l'empreinte carbone des produits (PCF) facile à utiliser dans Catena-X.",
    "recentRequests": "Demandes récentes de données PCF",
    "viewAllRequests": "Voir toutes les demandes",
    "requestPcf": "Demander PCF",
    "termCheck": "En soumettant la demande, je comprends que le contrat sera négocié sur l'offre de données selon les politiques définies par le fournisseur de données.",
    "pcfSuccess": "PCF demandé avec succès !",
    "landing": {
      "pcfTitle": "Créer une offre PCF",
      "pcfDesc": "Créez et partagez les données PCF avec les participants du réseau Catena-X.",
      "discoverTitle": "Découvrir et demander des données PCF",
      "discoverDesc": "Recherchez facilement des données PCF dans le réseau Catena-X ou demandez les données PCF à vos partenaires en quelques étapes.",
      "pcfReqTitle": "Demandes de données PCF",
      "pcfReqDesc": "Gérez efficacement les demandes de données PCF de vos partenaires dans le réseau Catena-X.",
      "pcfCalcTitle": "Calculateur PCF",
      "pcfCalcDesc": "Calculez les valeurs PCF et connectez-vous à vos applications ou scénarios d'échange de données PCF sans problème.",
      "pcfHistoryTitle": "Historique d'échange de données PCF",
      "pcfHistoryDesc": "Gagnez en transparence sur votre historique d'échange de données PCF dans le réseau Catena-X et avec vos partenaires.",
      "documentation": "En savoir plus sur l'échange de données PCF",
      "howTo": {
        "description": "Partagez, découvrez et gérez les offres de données d'empreinte carbone des produits (PCF) dans Catena-X.",
        "doc": "Vous voulez en savoir plus sur Connect & Integrate ? Lien de documentation : "
      }
    },
    "requests": {
      "pcfRequests": "Demandes de données PCF",
      "reqDesc": "Utilisez cette zone pour gérer vos demandes de données PCF des partenaires.",
      "productId": "ID du produit*",
      "bpn": "BPN*",
      "message": "Message",
      "howTo": {
        "title": "Vous voulez en savoir plus sur le fonctionnement de la gestion des demandes de données PCF ?",
        "description": "Utilisez cette section pour approuver ou rejeter la demande de données PCF de vos partenaires. De plus, consultez les statuts des échanges de données PCF et obtenez une transparence totale dans votre chaîne de données PCF.",
        "doc": "Vous voulez en savoir plus sur le fonctionnement de la négociation et de la consommation des offres de données ?"
      }
    },
    "responses": {
      "howTo": {
        "description": "Découvrez le catalogue d'offres de données d'autres entreprises membres de Catena-X. Vous pouvez rechercher, sélectionner et vous abonner à une offre de données. Vous pouvez rechercher des offres de données en utilisant le nom de l'entreprise ou avec l'ID de pièce du fabricant ou avec une combinaison des deux."
      }
    },
    "view": {
      "title": "Voir les détails PCF"
    }
  },
  "publicationTemplates": {
    "title": "Mes modèles de publication",
    "deletedTemplates": "Mes modèles supprimés",
    "showDeletedTemplates": "Afficher les modèles supprimés",
    "hideDeletedTemplates": "Afficher les modèles actifs",
    "newTemplate": "Nouveau modèle",
    "create": {
      "title": "Créer un modèle de publication",
      "edit": "Modifier le modèle de publication",
      "templateName": "Nom du modèle",
      "templateType": "Modèle de {type}",
      "create": "Créer",
      "update": "Mettre à jour",
      "name": "Nom",
      "createdAt": "Créé le",
      "modifiedAt": "Modifié le",
      "country": "Pays",
      "accessPolicyId": "Politique d'accès",
      "usagePolicyId": "Politique d'utilisation",
      "id": "ID",
      "createdBy": "Créé par",
      "modifiedBy": "Modifié par",
      "isEnabled": "Est activé",
      "targetCompany": "Entreprise cible",
      "targetConnectors": "Connecteurs cibles",
      "selectCountry": "Sélectionner un pays",
      "templateDetails": "Détails du modèle de publication",
      "assetsCriteria": "Critères de sélection d'actifs",
      "connectorDetails": "Détails du connecteur"
    },
    "delete": {
      "title": "Supprimer le modèle de publication",
      "description": "Êtes-vous sûr de vouloir supprimer ce modèle ?",
      "button": "Supprimer"
    }
  },
  "contracts": {
    "title": "Détails des accords contractuels",
    "provider": {
      "description": "Voici un aperçu des accords contractuels que votre organisation a avec d'autres participants à l'espace de données.",
      "howItWorks": {
        "description": "Ici, vous pouvez trouver tous vos accords de données souscrits ou négociés dans divers espaces de données. Vous pouvez filtrer les résultats pour un connecteur particulier ou simplement rechercher avec un ID d'accord contractuel ou un ID d'actif. Vous pouvez également trier la liste pour voir les accords de données selon vos besoins. De plus, vous pouvez sélectionner les offres de données et les exporter localement si vous le souhaitez.",
        "subtitle": "Vous voulez en savoir plus sur le fonctionnement de la négociation et de la consommation des offres de données ?"
      },
      "details": {
        "title": "Détails des accords contractuels fournis",
        "description": "Description",
        "content": "Contenu",
        "agreementDetails": "Détails de l'accord",
        "assetDetails": "Détails de l'actif",
        "usagePolicy": "Politique d'utilisation"
      }
    },
    "consumer": {
      "description": "Voici un aperçu des accords contractuels que votre organisation a pour les offres de données d'autres participants à l'espace de données ",
      "downloadData": "Télécharger les données",
      "downloadAgreement": "Télécharger l'accord",
      "reinitiate": "Initier le transfert et télécharger les données",
      "error": {
        "heading": "Désolé ! Il semble que vous ayez déjà négocié ce contrat.",
        "body": "Vous ne pouvez pas renégocier un contrat déjà négocié. Vous pouvez trouver les détails du contrat ci-dessous et vous pouvez également télécharger cet accord et souscrire aux données."
      },
      "details": {
        "title": "Détails des accords contractuels consommés"
      },
      "howItWorks": {
        "description": "Ici, vous pouvez trouver tous vos accords de données souscrits ou négociés dans divers espaces de données. Vous pouvez filtrer les résultats pour un connecteur particulier ou simplement rechercher avec un ID d'accord contractuel ou un ID d'actif. Vous pouvez également trier la liste pour voir les accords de données selon vos besoins. De plus, vous pouvez sélectionner les offres de données et les exporter localement si vous le souhaitez.",
        "subtitle": "Vous voulez en savoir plus sur le fonctionnement de la négociation et de la consommation des offres de données ?"
      }
    }
  },
  "provider": {
    "provider": "Fournisseur",
    "assets": {
      "title": "Mes actifs",
      "offeredBy": "Offert par :",
      "offers": "Offres",
      "created": "Créé",
      "modifiedAt": "Modifié le",
      "noResultsFound": "Aucun actif trouvé",
      "success": "Actif créé avec succès",
      "updateSuccess": "Actif mis à jour avec succès",
      "buttons": {
        "createOffer": "Créer une offre",
        "details": "Voir les détails",
        "delete": "Supprimer l'actif",
        "create": "Créer un actif",
        "close": "Fermer",
        "edit": "Modifier l'actif",
        "update": "Mettre à jour l'actif",
        "showDeleted": "Afficher les actifs supprimés",
        "hideDeleted": "Masquer les actifs supprimés",
        "restore": "Restaurer l'actif",
        "save": "Enregistrer",
        "add": "Ajouter une paire clé-valeur",
        "addJson": "Ajouter un objet json",
        "editJson": "Modifier l'objet json",
        "saveJson": "Enregistrer JSON",
        "advanceAddition": "Ajout avancé",
        "unpublish": "Actif non publié",
        "showAssets": "Afficher les actifs"
      },
      "detailsDialog": {
        "title": "Détails de l'actif"
      },
      "createDialog": {
        "title": {
          "general": "Créer un nouvel actif",
          "edit": "Modifier l'actif",
          "addProperties": "Ajouter des propriétés",
          "advance": "Ajout de propriété avancé"
        },
        "publicProps": "Propriétés publiques",
        "privateProps": "Propriétés privées",
        "dataAddress": "Adresse de données",
        "dataSources": "Source de données",
        "dataDestination": "Destination des données",
        "json": {
          "fields": "Champs Json",
          "editor": "Éditeur de propriétés personnalisées",
          "formatted": "Visualiseur de propriétés personnalisées",
          "error": "JSON invalide :"
        },
        "connectionTypeLabel": {
          "http": "Saisir l’URL",
          "s3": "Saisir le nom de l’objet",
          "azure": "Saisir le nom du blob",
          "sftp": "Saisir le nom du fichier"
        },
        "fields": {
          "name": "Nom",
          "namePlaceholder": "Entrez le nom de l'offre",
          "id": "ID",
          "description": "Description",
          "contenttype": "Type de contenu",
          "contenttypePlaceholder": "Entrez le type de contenu",
          "contentType": "Type de contenu",
          "contentTypePlaceholder": "Entrez le type de contenu",
          "version": "Version",
          "keywords": "Mots-clés",
          "language": "Langue",
          "languagePlaceholder": "Sélectionnez la langue",
          "semanticId": "ID sémantique",
          "semanticIdPlaceholder": "Veuillez insérer l'ID sémantique",
          "dct:type": "dct:type",
          "dct:typePlaceholder": "Choisissez un type dct",
          "keywordsPlaceholder": "Ajouter des mots-clés",
          "descriptionPlaceholder": "Écrivez la description de l'offre",
          "versionPlaceholder": "Numéro de version",
          "dataType": "Type d'adresse de données",
          "dataTypePlaceholder": "Sélectionnez le type d'adresse de données",
          "dataAddressUrl": "URL de l'actif",
          "dataAddressUrlPlaceholder": "Entrez l'URL de l'actif",
          "targetCompany": "Entreprise cible",
          "targetCompanyPlaceholder": "Insérez une entreprise cible",
          "country": "Pays",
          "countryPlaceholder": "Insérez un pays",
          "key": "Clé",
          "keyPlaceholder": "Entrez la clé",
          "value": "Valeur",
          "valuePlaceholder": "Entrez la valeur",
          "assetType": "Type d'actif",
          "assetTypePlaceholder": "Entrez le type d'actif"
        },
        "validation": {
          "name": "Veuillez entrer un nom",
          "assetType": "Veuillez sélectionner un type d'actif",
          "contentType": "Veuillez entrer un type de contenu valide",
          "dataType": "Veuillez sélectionner un type de données valide",
          "targetCompany": "Veuillez entrer une entreprise cible valide",
          "country": "Veuillez entrer un pays valide"
        }
      },
      "tags": {
        "restricted": "Accès restreint",
        "unrestricted": "Sans restriction"
      },
      "search": {
        "title": "Filtres de recherche",
        "helperText": "Rechercher par nom d'actif, date de création ou type",
        "filters": {
          "byName": "Nom de l'actif",
          "byType": "Type d'actif",
          "byDate": "Date de modification"
        }
      },
      "delete": {
        "title": "Supprimer l'actif",
        "description": "Êtes-vous sûr de vouloir supprimer cet actif ?"
      },
      "unpublish": {
        "title": "Actif non publié",
        "description": "Êtes-vous sûr de vouloir déposer cet actif?"
      }
    },
    "fileUploadTerms": "Je comprends et confirme que j'ai correctement rempli toutes les informations requises et T-Systems n'est pas responsable en cas d'informations incorrectes et de rejet d'offre.",
    "fileUploadInfo": "T-Systems ne vérifie pas la validité des informations de métadonnées renseignées ici. Veuillez vous assurer que vous avez fourni des informations correctes et complètes.",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "Entrée unique",
    "bulkEntries": "Entrées en masse"
  },
  "home": {
    "title": "Connect & Integrate"
  },
  "gettingStarted": {
    "title": "Besoin d'aide pour commencer ?",
    "openWizard": "Ouvrir l'assistant",
    "yourDataOffering": "Votre offre de données",
    "yourAssets": "Actifs",
    "yourPolicies": "Mes politiques",
    "preconfiguredCatalogue": "Catalogue préconfiguré",
    "contractAgreements": "Accords contractuels",
    "incomingAgreements": "Accords entrants",
    "outgoingAgreements": "Accords sortants",
    "connectors": "Vos connecteurs",
    "providedAgreements": "Accords contractuels fournis",
    "consumedAgreements": "Accords contractuels consommés"
  },
  "yourConnection": {
    "title": "Vos connecteurs",
    "viewAllConnection": "Voir tous les connecteurs",
    "help": "Aide",
    "documentation": "Découvrez votre Connect & Integrate",
    "gettingStarted": "Guide de démarrage",
    "noUseCases": "Aucun cas d'utilisation disponible"
  },
  "wizardSelectionPopup": {
    "whatToLike": "Que souhaitez-vous faire aujourd'hui ?",
    "prepare": "Préparer",
    "govern": "Gouverner",
    "provide": "Fournir",
    "consume": "Consommer",
    "howToProvide": "Comment souhaitez-vous fournir des données aujourd'hui ?",
    "manual": "Manuel",
    "automated": "Automatisé via une API",
    "selectUseCases": "Sélectionnez vos cas d'utilisation",
    "selectSingleUseCase": "Sélectionnez votre cas d'utilisation",
    "selectDigitalTwin": "Sélectionnez votre type de jumeau numérique",
    "back": "Retour",
    "next": "Suivant",
    "publish": "Je comprends les exigences du cadre de l'espace de données et j'accepte de publier l'offre de données dans l'espace de données au nom de mon organisation."
  },
  "createOffer": {
    "title": {
      "standard": "Créer une offre de données",
      "pcf": "Créer une offre de données PCF",
      "certificate": "Créer une offre de certificat"
    },
    "publish": "Publier",
    "legalConfirmation": "Je comprends les exigences du cadre de l'espace de données et j'accepte de publier l'offre de données dans l'espace de données au nom de mon organisation.",
    "wizard": {
      "provisionAsset": "Provisionner l'actif",
      "dataUpload": "Sélection des données",
      "attachPolicy": "Attacher une politique",
      "publishDataOffer": "Publier l'offre de données"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "Pour quel sous-modèle souhaitez-vous créer une offre de données ?",
      "selectSubmodel": "Sélectionner un sous-modèle",
      "selectUsecase": "Sélectionner un cas d'utilisation",
      "selectDigitalTwinType": "Sélectionner un type de jumeau numérique",
      "whichTypeToSelect": "Quel type dois-je sélectionner ?",
      "generalInformation": "Informations générales",
      "name": "Nom",
      "id": "ID",
      "description": "Description",
      "contentType": "Type de contenu",
      "version": "Version",
      "keywords": "Mots-clés",
      "language": "Langue",
      "location": {
        "title": "Localisation et adressage",
        "text": "Veuillez saisir les détails de votre actif"
      },
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "assetUrl": "URL de l'actif",
      "assetUrlPlaceHolder": "Veuillez insérer l'URL de votre actif",
      "clientId": "ID client",
      "clientSecret": "Secret client",
      "tokenUrl": "URL du jeton",
      "tokenUrlPlaceHolder": "Veuillez insérer votre URL de jeton",
      "provideAssets": "Fournir un actif",
      "selectConnectorLabel": "Sélectionnez les connecteurs avec lesquels vous souhaitez partager vos données",
      "selectConnectorPlaceholder": "Sélectionner un connecteur",
      "selectRestApiType": "Sélectionner le type d'API REST",
      "selectedAuthMethod": "Méthode d'authentification"
    },
    "dataUpload": {
      "selectedDataModel": "Sélectionner vos données",
      "csvUpload": {
        "title": "Fichier CSV",
        "description": "Glissez-déposez vos fichiers ici",
        "uploadFile": "Sélectionner un fichier",
        "uploadFileDescription": "Préparez et téléchargez le fichier que vous souhaitez échanger. Vous pouvez télécharger le fichier exemple pour vous aider à démarrer avec le format requis pour Catena-X.",
        "uploadFileDescriptionNote1": "Téléchargez le fichier modèle à partir du lien ci-dessous",
        "uploadFileDescriptionNote2": "Remplissez le fichier fourni avec les détails de vos partenaires",
        "uploadFileDescriptionNote3": "Téléchargez le fichier dans la zone prévue",
        "partnerValidationNote": "Si vous souhaitez en savoir plus sur la validation des partenaires, veuillez",
        "clickHere": "cliquer ici",
        "downloadTemplate": "Télécharger le modèle",
        "downloadSampleCsv": "Télécharger l'exemple de CSV",
        "supportedFileTypes": "Types de fichiers pris en charge :"
      },
      "jsonUpload": {
        "title": "json",
        "description": "Écrivez votre propre code json"
      },
      "tableUpload": {
        "title": "Tableau",
        "description": "Fournir des entrées de table personnalisées",
        "add": "Ajouter"
      },
      "fileUpload": {
        "title": "Téléchargement de fichier",
        "description": "csv, json"
      },
      "objectStorage": {
        "title": "Stockage d'objets",
        "description": "AWS, Azure, OTC ou GCP"
      },
      "sftp": {
        "title": "Serveur SFTP",
        "description": "transfert via SFTP"
      },
      "apiUpload": {
        "title": "API REST",
        "description": "transfert via API",
        "authAndIdentiTitle": "Authentification et identification",
        "authAndIdentiDesc": "Veuillez saisir les détails d'authentification de votre système de destination",
        "selectApiType": "Sélectionner le type d'API REST",
        "locationAndAddrTitle": "Localisation et adressage",
        "locationAndAddrDesc": "Veuillez saisir les détails de votre actif",
        "assetUrl": "URL de l'actif",
        "username": "Nom d'utilisateur",
        "password": "Mot de passe",
        "clientId": "ID client",
        "clientSecret": "Secret client"
      }
    },
    "fileUpload": {
      "title": "Glissez et déposez votre fichier ici",
      "btnText": "Sélectionner un fichier"
    },
    "attachPolicy": {
      "title": "Attacher une politique à cette offre de données",
      "createPolicy": "Créer une nouvelle politique",
      "bpnFieldTitle": "Avec qui voulez-vous échanger vos données ?",
      "howItWork": {
        "title": "Comment ça marche ?",
        "description": "Nous préconfigurons les politiques basées sur l'accord-cadre du cas d'utilisation Catena-X. L'accès à vos données ne sera autorisé que pour les numéros de partenaires commerciaux fournis.",
        "knowMore": "Vous voulez en savoir plus sur les politiques ?",
        "documentation": "Documentation"
      },
      "accessPolicyTableText": "Attacher une politique d'accès à cette offre de données",
      "usagePolicyTableText": "Attacher une politique d'utilisation à cette offre de données",
      "heading": {
        "title": "Attacher des politiques existantes ou en créer de nouvelles",
        "description": "Veuillez attacher à la fois une politique d'accès et d'utilisation à partir des tableaux ci-dessous pour terminer la publication de l'offre de données. Vous pouvez également rechercher des politiques par leurs noms ou créer une nouvelle politique au cas où vous n'auriez pas encore la politique souhaitée."
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "Détails de l'offre de données",
      "generalInformation": "Informations générales",
      "attribute": "Attribut",
      "value": "Valeur",
      "knowMore": "En savoir plus sur votre offre de données",
      "attachedDataAssets": "Éléments attachés",
      "attachedPolicies": "Politiques attachées",
      "allowPolicyPublish": "J'autorise la publication de la politique",
      "publish": "Publier",
      "verifiedLegalEntity": "Entité juridique vérifiée par",
      "dataOfferCreatedBy": "Offre de données créée par : ",
      "contactOrgAdmin": "Contacter l'administrateur de l'organisation",
      "help": "Aide",
      "attachedDataAsset": "Actif de données attaché",
      "attachedAccessPolicy": "Politique d'accès attachée",
      "attachedUsagePolicy": "Politique d'utilisation attachée",
      "publishedConnectors": "Connecteurs auxquels cette offre sera publiée",
      "knowMoreConnector": "En savoir plus sur vos connecteurs",
      "knowMorePolicies": "En savoir plus sur vos politiques",
      "knowMoreDataAssets": "En savoir plus sur vos actifs de données",
      "knowMoreDataOffers": "En savoir plus sur votre offre de données",
      "publishCheckboxLabel": "Je, au nom de mon organisation, accepte de publier l'offre de données et les actifs dans l'espace de données. Je confirme l'utilisation des politiques associées pour gouverner l'espace de données et les politiques associées et je suivrai le cadre de l'espace de données pour toute opération sur l'offre et les actifs une fois publiés."
    },
    "result": {
      "success": {
        "title": "Demande réussie.",
        "description": "Processus de publication d'actif démarré ! L'ID du job est {id}"
      }
    },
    "success": {
      "title": "Votre offre de données est maintenant publiée",
      "description": "Votre offre de données est maintenant publiée, cliquez sur ce qui suit pour les prochaines étapes",
      "createOffer": "Créer une autre offre de données",
      "createOfferButton": "Créer",
      "goToHome": "Aller à l'accueil",
      "goToHomeButton": "Aller à l'accueil",
      "uploadHistory": "Vérifier votre historique de téléchargements"
    }
  },
  "policy": {
    "newPolicy": "Nouvelle politique",
    "showDeletedPolicies": "Afficher les politiques supprimées",
    "myDeletedPolicies": "Mes politiques supprimées",
    "hideDeletedPolicies": "Afficher les politiques actives",
    "restoreAsset": "Restaurer",
    "publishDeletion": "Publier la suppression",
    "create": {
      "title": "Créer une nouvelle politique",
      "edit": "Modifier la politique",
      "policyName": "Nom de la politique",
      "policyType": "Politique de {type}",
      "accessPolicy": "Politique d'accès",
      "usagePolicy": "Politique d'utilisation",
      "create": "Créer et enregistrer",
      "update": "Mettre à jour"
    },
    "delete": {
      "title": "Supprimer la politique",
      "description": "Êtes-vous sûr de vouloir supprimer cette politique ?",
      "button": "Supprimer"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "Numéro de partenaire commercial",
        "description": "La restriction du numéro de partenaire commercial peut être utilisée pour définir quels partenaires commerciaux exacts (sur la base de BPNL) sont autorisés à consulter ou à négocier l'offre de données respective. "
      },
      "BusinessPartnerGroup": {
        "title": "Groupe de partenaires commerciaux",
        "description": "La restriction de groupe de partenaires commerciaux peut être utilisée pour définir quels partenaires commerciaux exacts (sur la base de BPNL) sont autorisés à consulter ou à négocier l'offre de données respective. "
      },
      "Membership": {
        "title": "Adhésion",
        "description": "Les informations d'identification d'adhésion peuvent être utilisées pour garantir que seuls les membres CX sont autorisés à consulter ou à négocier l'offre de données respective."
      },
      "ContractReference": {
        "title": "Référence du contrat",
        "description": "La restriction de référence du contrat peut être utilisée pour définir les détails du contrat bilatéral dans lesquels les données sont partagées. "
      },
      "Dismantler": {
        "title": "Démantèleur",
        "description": "Les entreprises détentrices du titre sont des entreprises certifiées en matière de démantèlement.",
        "allowedBrands": {
          "title": "Marques autorisées du démantèleur",
          "description": "Rôle d'entreprise définissant un démantèleur. Les entreprises détentrices du titre sont des entreprises certifiées en matière de démantèlement."
        }
      },
      "UsagePurpose": {
        "title": "Objectif d'utilisation",
        "description": "Objectif d'utilisation"
      },
      "FrameworkAgreement": {
        "title": "Accord-cadre",
        "description": "Avec le FrameworkAgreement Credential, seuls les participants qui ont signé l'accord-cadre respectif (général ou via une version spécifique) sont autorisés à consulter ou à négocier l'offre de données respective. "
      },
      "Duration": {
        "title": "Durée",
        "description": "Durée d'utilisation des données à partir de la date de signature."
      },
      "inForceDate": {
        "title": "Plage de dates fixe",
        "description": "Période de date fixe pour l’utilisation des données."
      },
      "connector": {
        "title": "Restriction du connecteur",
        "description": "Entreprises détenant les connecteurs à utiliser pour leur restriction."
      }
    },
    "fields": {
      "BusinessPartnerNumber": "Numéro de partenaire commercial",
      "tx:BusinessPartnerGroup": "Groupe de partenaires commerciaux",
      "cx-policy:Membership": "Adhésion",
      "cx-policy:ContractReference": "Référence du contrat",
      "cx-policy:Dismantler.allowedBrands": "Marques autorisées du démantèleur",
      "cx-policy:Dismantler": {},
      "cx-policy:UsagePurpose": "Objectif d'utilisation",
      "cx-policy:FrameworkAgreement": "Accord-cadre",
      "duration": "Durée",
      "unit": "Unité",
      "fromdate": "À partir de la date",
      "todate": "À ce jour",
      "connector": "Connecteur"
    }
  },
  "jobs": {
    "jobs": "Jobs",
    "id": "Id",
    "name": "Nom",
    "startedAt": "Commencé à",
    "status": "Statut",
    "duration": "Durée",
    "action": "Actions",
    "jobDetails": "Détails du processus",
    "reload": "Recharger",
    "noDetailsAvailable": "Aucun détail supplémentaire disponible pour ce job",
    "retry": "Réessayer"
  },
  "search-offer": {
    "pageTitle": "Rechercher des offres de données",
    "pcfTitle": "Rechercher des offres de données PCF",
    "certificateTitle": "Rechercher des offres de certificats de partenaires commerciaux",
    "filter": {
      "bpnSearch": "Rechercher par votre numéro de partenaire commercial ou un nom d'entreprise",
      "bpnSearchNote": "Trouvez les offres de données en recherchant avec le nom de l'entreprise ou le BPN.",
      "manufacturePartId": "ID de pièce du fabricant",
      "manufacturePartIdNote": "Recherche toutes les offres de données correspondant à l'ID de pièce donné.",
      "enter": "Entrer {field}",
      "connectorUrl": "URL du connecteur",
      "connectorUrlNote": "Rechercher des données dans des connecteurs spécifiques",
      "subModel": "Sous-modèle",
      "subModelNote": "Affinez vos résultats de recherche pour votre cas d'utilisation souhaité",
      "search": "Rechercher",
      "searchBy": "Rechercher par",
      "resetFilters": "Réinitialiser les filtres",
      "advancedSearch": "Recherche avancée",
      "name": "Nom",
      "dct:type": "dct:type",
      "assetId": "ID d'actif"
    },
    "noResult": {
      "title": "Aucun résultat",
      "description": "Veuillez effectuer une recherche pour parcourir les offres de données disponibles dans le réseau"
    },
    "helpCard": {
      "title": "Comment ça marche ?",
      "description": "Découvrez le catalogue d'offres de données d'autres participants à l'espace de données. Vous pouvez rechercher, sélectionner et vous abonner aux offres de données disponibles dans l'espace de données.",
      "subtitle": "Vous voulez en savoir plus sur le fonctionnement de la négociation et de la consommation des offres de données ?",
      "documentation": "Documentation"
    },
    "offers": {
      "downloadSelected": "Télécharger la sélection",
      "transferSelected": "Transférer la sélection",
      "negotiate": "Négocier",
      "noOffer": "Aucune offre de données n'est disponible."
    },
    "offer-details": {
      "title": "Confirmer les négociations contractuelles",
      "description": "Description",
      "details": "Détails",
      "attachedPolicies": "Politiques attachées",
      "termsCheck": "J'accepte les termes du contrat et je souhaite démarrer la négociation du contrat et l'échange de données.",
      "negotiate": "Négocier",
      "negotiateAndDownload": "Négocier et télécharger",
      "negotiateAndTransfer": "Négocier et transférer",
      "transfer": "Transférer",
      "cancel": "Annuler",
      "attribute": "Attribut",
      "value": "Valeur",
      "endpointUrl": "URL du point de terminaison",
      "organization": "Organisation",
      "bpnNumber": "Numéro BPN",
      "manufacturerPartId": "ID de pièce du fabricant",
      "noOfAssets": "Nombre d'actifs sélectionnés",
      "membership": "Adhésion",
      "dismantlerBrands": "Marques autorisées pour le démantèlement",
      "frameworkAgreement": "Accord-cadre",
      "dismantler": "Démantèleur",
      "backToAssets": "Retour aux actifs",
      "noPolicyMatchTitle": "Actifs non négociés ou politiques non identiques",
      "noPolicyMatchText": "Vous essayez de télécharger des actifs qui n'ont pas encore été négociés. Ou certains des actifs que vous essayez de négocier n'ont pas des politiques identiques. Veuillez sélectionner les bons actifs et continuer.",
      "negotiateInProgress": "Négociation et téléchargement en cours",
      "negotiateAndDownloadSuccess": "Négociation et téléchargement terminés avec succès",
      "negotiateAndTransferSuccess": "Négociation et transfert terminés avec succès",
      "transferSuccess": "Transfert terminé avec succès",
      "progress": "Progression",
      "fetchShell": "Récupération du shell",
      "exportToCSV": "Exporter en CSV",
      "fetchJobFailed": "Erreur lors de la récupération des détails du job",
      "negotiateError": "Erreur lors du téléchargement des actifs",
      "dtr": "Registre de jumeaux numériques",
      "edc": "Actifs du connecteur",
      "browseDtr": "Parcourir le DTR"
    },
    "dtr": {
      "title": "Shells de jumeaux numériques",
      "shells": "Parcourir les shells",
      "description": "Vous allez négocier automatiquement la récupération et l'exportation des Shells depuis le registre de jumeaux numériques du fournisseur sélectionné"
    }
  },
  "assetUploadHistory": {
    "title": "Historique des téléchargements d'actifs",
    "subtitle": "Cet historique donne un aperçu des transactions sur les connecteurs d'espace de données de votre entreprise. Toutes les activités sur les actifs, les politiques et les définitions de contrat sont listées ici.",
    "refresh": "Actualiser",
    "processId": "ID du processus",
    "providerUrl": "URL du fournisseur",
    "createdOn": "Créé le",
    "totalItems": "Total des éléments",
    "successful": "Réussi",
    "failed": "Échoué",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "status": "Statut",
    "actions": "Actions",
    "howItWork": {
      "title": "Comment ça marche ?",
      "description": "Vous pouvez trouver l'historique de tous vos actifs téléchargés dans différents espaces de données. Vous pouvez télécharger à nouveau les fichiers localement ou les transférer vers un emplacement externe. En cas d'erreurs, vous devez réessayer de télécharger ou renégocier l'offre de données.",
      "moreInfo": "Vous voulez en savoir plus sur l'historique des téléchargements et tout ce que vous pouvez faire ici ?"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "L'historique vous donne un aperçu des données téléchargées par votre organisation disponibles à partir des contrats négociés dans l'espace de données. Si nécessaire, vous pouvez télécharger à nouveau les données à partir de cette liste d'historique.",
    "howItWorks": {
      "description": "Vous pouvez trouver l'historique de tous vos actifs téléchargés dans différents espaces de données. Vous pouvez télécharger à nouveau les fichiers localement ou les transférer vers un emplacement externe. En cas d'erreurs, vous devez réessayer de télécharger ou renégocier l'offre de données.",
      "moreInfo": "Vous voulez en savoir plus sur l'historique des téléchargements et tout ce que vous pouvez faire ici ?"
    },
    "downloadError": "Téléchargement échoué, veuillez réessayer !",
    "viewErrors": "Voir les erreurs"
  },
  "digitalTwinBrowser": {
    "subHeading": "Voici vos jumeaux numériques et leurs sous-modèles. Vos jumeaux numériques sont exposés à l'espace de données via votre registre de jumeaux numériques.",
    "noDocumentError": "Aucun document d'aspect pour l'id actuel",
    "nameNotProvided": "Nom non fourni",
    "fetchDigitalTwinsError": "Échec de la récupération des jumeaux numériques",
    "fetchAspectDocumentError": "Échec de la récupération du document d'aspect",
    "fetchAspectModelError": "Échec de la récupération du modèle d'aspect",
    "detailsOverviewModalTitle": "Détails de l'aspect",
    "addItem": "Ajouter un élément",
    "detailsTable": {
      "id": "ID",
      "idShort": "ID court",
      "displayName": "Nom d'affichage",
      "modelUrn": "URN du modèle"
    },
    "shellsTable": {
      "id": "ID",
      "name": "Nom",
      "manufacturer": "ID de pièce du fabricant",
      "modifiedBy": "Utilisateur",
      "modifiedAt": "Heure"
    }
  },
  "connector": {
    "addNewConnector": "+ Ajouter un nouveau connecteur",
    "searchConnector": "Rechercher par nom du connecteur",
    "connectorModal": {
      "error": "Échec de la récupération des détails du connecteur"
    }
  },
  "column": {
    "name": "Nom",
    "connectorName": "Nom du connecteur",
    "contractId": "ID du contrat",
    "productId": "ID du produit",
    "manufacturerPartId": "ID de pièce du fabricant",
    "manufacturerId": "ID du fabricant",
    "digitalTwinType": "Type de jumeau numérique",
    "correlationId": "ID de corrélation",
    "requestId": "ID de demande",
    "bpn": "BPN",
    "createdAt": "Créé le",
    "createdBy": "Créé par",
    "attribute": "Attribut",
    "url": "URL",
    "actions": "Actions",
    "lastUpdatedTime": "Dernière mise à jour",
    "status": "Statut",
    "requestedDate": "Date de demande",
    "policyType": "Type de politique",
    "modifiedBy": "Modifié par",
    "modifiedOn": "Modifié le",
    "syncStatus": "Statut de synchronisation",
    "assetId": "ID d'actif",
    "assetType": "Type d'actif",
    "type": "Type",
    "createdFrom": "Créé à partir de",
    "createdTo": "Créé jusqu'à",
    "statusDuration": "Statut/Durée",
    "certifier": "Certificateur",
    "version": "Version",
    "registrationNumber": "N° d'enregistrement",
    "validUntil": "Valable jusqu'au",
    "offerId": "ID de l’offre",
    "errorMessage": "Message d'erreur",
    "globalAssetId": "ID d’actif global",
    "shellName": "Nom du shell",
    "contractAgreementId": "ID de l'accord contractuel",
    "signingDate": "Date de signature",
    "providerConnectorUrl": "URL du connecteur du fournisseur",
    "consumerConnectorUrl": "URL du connecteur du consommateur",
    "providerBpnl": "BPNL du fournisseur",
    "consumerBpnl": "BPNL du consommateur",
    "counterPartyId": "ID de la contrepartie",
    "resourceId": "ID de la ressource",
    "resourceType": "Type de ressource",
    "transactionMethod": "Méthode de transaction",
    "trustLevel": "Niveau de confiance"
  },
  "messagesBrowser": {
    "fetchMessagesError": "Échec de la récupération des messages",
    "openRelatedMessage": "Ouvrir le message associé",
    "messagesTable": {
      "id": "ID",
      "name": "Nom",
      "createdAt": "Créé le",
      "createdBy": "Créé par",
      "type": "Type",
      "context": "Contexte",
      "senderBpn": "BPN de l'expéditeur",
      "receiverBpn": "BPN du destinataire",
      "correlationId": "ID de corrélation",
      "jobId": "ID du job",
      "conversationId": "ID de conversation",
      "status": "Statut"
    },
    "messageType": {
      "ecu": "ECU",
      "generic": "Générique",
      "quality": "Qualité",
      "ccmpush": "CCM Push",
      "ccmrequest": "Requête CCM",
      "ccmstatus": "Statut CCM",
      "ccmavailable": "CCM Disponible"
    }
  },
  "bpnSelector": {
    "selectFromList": "Sélectionner dans la liste",
    "enterManually": "Entrez manuellement",
    "selectPlaceholder": "Sélectionnez un emplacement BPN",
    "manualPlaceholder": "Saisissez BPN (par exemple, BPNL123456789ABC)",
    "validFormat": "Format BPN valide",
    "invalidFormat": "Format BPN invalide",
    "invalidFormatHint": "Format : BPNL + 12 caractères alphanumériques",
    "formatHint": "Format : BPNL123456789ABC (16 caractères au total)",
    "selected": "Choisi"
  },
  "searchableSelect": {
    "pressEnterToUse": "Appuyez sur Entrée pour utiliser ce BPNA/BPNS",
    "placeholderText": "Veuillez saisir un BPNA/BPNS valide",
    "placeholder": "Sélectionnez ou saisissez un BPNA/BPNS"
  }
}
